module.exports = __webpack_public_path__ + "static/media/img-small-1.004b731d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/img-small-1.png
// module id = 262
// module chunks = 0